import { render, staticRenderFns } from "./BranchClearGoods.vue?vue&type=template&id=6534d692"
import script from "./BranchClearGoods.vue?vue&type=script&lang=js"
export * from "./BranchClearGoods.vue?vue&type=script&lang=js"
import style0 from "./BranchClearGoods.vue?vue&type=style&index=0&id=6534d692&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports